import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import Card from '@vtex/styleguide/lib/Card'
import Button from '@vtex/styleguide/lib/Button'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import {
  getTitleIdByConfigurationType,
  getDeviceLabelIdByConfigurationType,
  hasPrinterConfiguration,
} from '../utils'
import { DEVICE_CONFIGURATION_TYPES } from '../constants'

class DeviceCard extends React.Component {
  render() {
    const { configType, defaultPrinter, intl } = this.props
    let printerName = '-'

    if (
      hasPrinterConfiguration(configType) &&
      defaultPrinter &&
      defaultPrinter.device
    ) {
      const {
        name,
        device: { deviceName },
      } = defaultPrinter
      printerName = `${
        name ||
        intl.formatMessage({
          id: 'defaultDevicePrinter',
        })
      } - ${deviceName}`
    }

    return (
      <div className="ph9 pv5 ph1-ns">
        <Card>
          <div className="mb6">
            <div className={'mb3 lh-solid f4 black'}>
              <FormattedMessage
                id={getTitleIdByConfigurationType(configType)}
              />
            </div>
          </div>
          <div
            className={'mb6 bb b--black-20'}
            style={{ marginLeft: '-24px', marginRight: '-24px' }}
          />
          <div className="mb6">
            <div className={'mb3 lh-solid f5 black-50'}>
              <FormattedMessage
                id={getDeviceLabelIdByConfigurationType(configType)}
              />
            </div>
            <div className={'mb6 lh-solid f5 black'} data-testid="device-name">
              {this.props.deviceName}
            </div>
          </div>
          {hasPrinterConfiguration(configType) ? (
            <React.Fragment>
              <div className="mb6">
                <div className={'mb3 lh-solid f5 black-50'}>
                  <FormattedMessage id="defaultPrinter" />
                </div>
                <div
                  className={'mb3 lh-solid f5 black'}
                  data-testid="printer-name"
                >
                  {printerName}
                </div>
              </div>

              <Button
                variation="tertiary"
                size="regular"
                collapseLeft
                onClick={this.props.onEditClick}
              >
                <FormattedMessage id="change" />
              </Button>
            </React.Fragment>
          ) : null}
        </Card>
      </div>
    )
  }
}

DeviceCard.propTypes = {
  deviceName: PropTypes.string,
  defaultPrinter: PropTypes.object,
  intl: intlShape,
  configType: PropTypes.oneOf(DEVICE_CONFIGURATION_TYPES).isRequired,
  onEditClick: PropTypes.func.isRequired,
}

export default withRouter(injectIntl(DeviceCard))
